module.exports = __webpack_public_path__ + "static/img/testimony (42).1db9d5e9.jpg";